const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  name: (state) => state.user.name,
  region: (state) => state.user.region,
  mediaUrl: () => process.env.VUE_APP_BASE_API + "/media",
  siteUrl: () => process.env.VUE_APP_SITE_URL,
  roles: (state) => state.user.roles,
  permission_routes: (state) => state.permission.routes,
  locations: (state) => state.locations.locations,
  pollingToken: (state) => state.polling.token,
  isAbleToSeeRegions: (state) => {
    return state.user.roles.includes("admin");
  },
  selectedContentId: (state) => state.user.selectedContentId,
};
export default getters;
